import { createFileRoute } from '@tanstack/react-router'

import PageToolMask from '../pages/PageToolMask'

export const Route = createFileRoute('/tools/mask')({
  component: PageToolMask
})
